var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.editMode)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('JobDetailsField',{attrs:{"header":"Name","value":_vm.name}})],1):_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"value":_vm.name,"box":"","persistent-hint":"","required":"","hint":"*Required","label":"Name*","counter":_vm.nameCounter,"rules":_vm.nameRules},on:{"change":_vm.changeName}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eab45df","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/jobs_overview/job_details_view/job_info/NameSection.vue
// module id = 415
// module chunks = 1